export default "__VITE_ASSET__BZoHDpbG__"